import axios from "axios";
import { getCookieValue } from "./cookies";
import { useSWRMutate } from "./useSWR";
import t from "./translate";
import { getRecaptchaToken } from "./getRecaptchaToken";
import { ENROLL_RECAPTCHA_ACTION_KEY } from "./constants";
import { logger } from "./logger";

const smsService = axios.create({
  baseURL: window.ww.wwAPI,
  timeout: 10000
});

export const ERROR_MESSAGING_TO_SHOW = [
  "InvalidRequestError",
  "clinicalSwitchNotEligible",
  "activeClinicalSubcriptionFound",
  "RecurlyTransactionError"
];

const ACTIVE_SUBSCRIPTION = "already has an active subscription";

async function preview(_, { arg }) {
  const { market, payload } = arg;
  const token = getCookieValue("wwSession");

  logger("Getting SMS preview", {
    level: "info"
  });

  try {
    const response = await smsService.post(
      `/sms/v1/preview?locale=${market}`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );

    logger("Successfully got SMS preview", {
      level: "info"
    });

    return response;
  } catch (error) {
    logger("Error getting SMS preview", {
      level: "error",
      customAttributes: { error }
    });
    throw error?.response?.data?.message || t("CLINIC_CHECKOUT_ERROR");
  }
}

async function enroll(_, { arg }) {
  const { market, payload, authData, setAuthData } = arg;
  const token = getCookieValue("wwSession");
  const recaptchaToken = await getRecaptchaToken(ENROLL_RECAPTCHA_ACTION_KEY);

  logger("Enrolling user", {
    level: "info"
  });

  try {
    const response = await smsService.post(
      `/sms/v1/subscriptions/enroll?locale=${market}&source=checkout`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          ...(recaptchaToken ? { "X-Recaptcha-Token": recaptchaToken } : {})
        }
      }
    );

    logger("Successfully enrolled user", {
      level: "info"
    });

    return response;
  } catch (error) {
    logger("Error enrolling user", {
      level: "error",
      customAttributes: { error }
    });

    if (error?.response?.status === 401) {
      setAuthData({ ...authData, loggedInAs: "" });
      throw t("LOGIN_REQUIRED_ERROR");
    } else if (ERROR_MESSAGING_TO_SHOW.includes(error?.response?.data?.name)) {
      if (
        typeof error?.response?.data?.explanation === "string" &&
        error?.response?.data?.explanation?.includes(ACTIVE_SUBSCRIPTION)
      ) {
        throw t("EXISTING_ACCOUNT_ERROR");
      } else {
        throw error?.response?.data?.message || t("CLINIC_CHECKOUT_ERROR");
      }
    } else {
      throw t("CLINIC_CHECKOUT_ERROR");
    }
  }
}

export const useEnroll = () =>
  useSWRMutate("enroll", enroll, {
    throwOnError: true
  });

export const usePreview = () =>
  useSWRMutate("preview", preview, {
    throwOnError: true
  });
